<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_238_99)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM16.3425 10.3425C16.7525 9.93241 16.7525 9.26759 16.3425 8.85754C15.9324 8.44749 15.2676 8.44749 14.8575 8.85754L10.8 12.9151L9.14246 11.2575C8.73241 10.8475 8.06759 10.8475 7.65754 11.2575C7.24749 11.6676 7.24749 12.3324 7.65754 12.7425L10.0575 15.1425C10.4676 15.5525 11.1324 15.5525 11.5425 15.1425L16.3425 10.3425Z" fill="#5B6770"/>
</g>
<defs>
<clipPath id="clip0_238_99">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
